export default{
  // Used in Blog and HC SubmitRequest Search bar, input fields in forms;
  mobilingo_standard: {
    root: "relative w-full items-center",
    label: "block text-base font-medium text-text mb-2",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none",
    input:
    "rounded-full w-full pl-7 pr-4 py-3 text-[16px] md:text-[17px] lg:text-[20px] bg-gray_100 border border-bordered focus:outline-none focus:border-primary",
    input_with_icon: "pl-[56px]",
    textarea:
      "w-full px-4 py-3 text-lg",
    error_text: "mt-2 text-sm text-error",
    error_state: "border-error",
  },

  // Used in HC Header Search bar
  mobilingo_big_search: {
    root: "relative w-full items-center",
    label: "block text-xl font-medium text-gray_700 mb-2",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-8 text-lg bg-paper border-none focus:outline-1 focus:outline-primary focus:shadow-card_shadow",
    input_with_icon: "pl-16",
    textarea:
      "w-full text-lg",
    error_text: "mt-2 text-sm text-error",
    error_state: "border-error",
  },
}